import { escapeHtml } from '../format'

/**
 * barBreakdown din public/js/discovery.js - barele de sub By type / By OS.
 */

export function barBreakdownHtml(
  data: Record<string, unknown>[],
  opts: { labelField: string; valueField: string; empty: string },
): string {
  const rows: { label: string; value: number }[] = []
  let total = 0
  for (const row of data || []) {
    const value = parseInt(String(row[opts.valueField] ?? 0), 10) || 0
    if (value < 1) continue
    total += value
    rows.push({ label: String(row[opts.labelField] || '—'), value })
  }
  if (!rows.length) return `<div class="nd-bd-empty">${opts.empty}</div>`
  rows.sort((a, b) => b.value - a.value)
  const max = rows[0]!.value
  const isUnknown = (label: string) => {
    const l = label.toLowerCase()
    return l.includes('unidentified') || l.includes('unknown') || l === '—'
  }
  let html = `<div class="nd-bd" role="img" aria-label="${total} in total, pe categorii">`
  for (const row of rows) {
    const share = Math.round((row.value / total) * 100)
    const width = Math.max(2, Math.round((row.value / max) * 100))
    html += `<div class="nd-bd-row${isUnknown(row.label) ? ' is-unknown' : ''}"`
      + ` title="${row.label}: ${row.value} of ${total} (${share}%)">`
      + `<span class="nd-bd-label">${escapeHtml(row.label)}</span>`
      + `<span class="nd-bd-track"><span class="nd-bd-fill" style="width:${width}%"></span></span>`
      + `<span class="nd-bd-value">${row.value}</span></div>`
  }
  html += `<div class="nd-bd-total">${total} in total</div></div>`
  return html
}
